import { render, staticRenderFns } from "./address-check.vue?vue&type=template&id=25d3b1fa"
import script from "./address-check.vue?vue&type=script&lang=js"
export * from "./address-check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports